import { TranslateService } from '@ngx-translate/core';

export class ErrorMessage {
  private static translate: TranslateService;

  static init(translateService: TranslateService) {
    this.translate = translateService;
  }

  static getMessage(errorType: string, params?: any): string {
    switch (errorType) {
      case 'required':
      case 'pattern':
      case 'email':
      case 'phone':
      case 'exactTwoFiles':
      case 'vatTaken':
      case 'emailTaken':
      case 'phoneTaken':
      case 'whatsappTaken':
      case 'phoneBelongsToClinic':
        return this.translate.instant(`validation.${errorType}`);

      case 'minlength':
        return this.translate.instant(`validation.minlength`, { min: params?.requiredLength });

      case 'maxlength':
        return this.translate.instant(`validation.maxlength`, { max: params?.requiredLength });
      case 'minFiles':
        return this.translate.instant('validation.minFiles', {
          required: params?.required,
          actual: params?.actual,
        });
      case 'link':
        return this.translate.instant('validation.linkValidator');
      case 'mustBeChecked':
        return this.translate.instant('validation.mustBeChecked');
      default:
        return this.translate.instant('validation.unknown');
    }
  }
}


export function buildValidationMessages(): any[] {
  return [
    { name: 'required', message: () => ErrorMessage.getMessage('required') },
    { name: 'minlength', message: (err: any) => ErrorMessage.getMessage('minlength', err) },
    { name: 'maxlength', message: (err: any) => ErrorMessage.getMessage('maxlength', err) },
    { name: 'pattern', message: () => ErrorMessage.getMessage('pattern') },
    { name: 'email', message: () => ErrorMessage.getMessage('email') },
    { name: 'phone', message: () => ErrorMessage.getMessage('phone') },
    { name: 'exactTwoFiles', message: () => ErrorMessage.getMessage('exactTwoFiles') },
    { name: 'minFiles', message: (err: any) => ErrorMessage.getMessage('minFiles', err) },
    { name: 'link', message: () => ErrorMessage.getMessage('link') },
    { name: 'unknown', message: () => ErrorMessage.getMessage('unknown') },
    { name: 'mustBeChecked', message: () => ErrorMessage.getMessage('mustBeChecked') },
    { name: 'vatTaken', message: () => ErrorMessage.getMessage('vatTaken') },
    { name: 'emailTaken', message: () => ErrorMessage.getMessage('emailTaken') },
    { name: 'phoneTaken', message: () => ErrorMessage.getMessage('phoneTaken') },
    { name: 'whatsappTaken', message: () => ErrorMessage.getMessage('whatsappTaken') },
    { name: 'phoneBelongsToClinic', message: () => ErrorMessage.getMessage('phoneBelongsToClinic') },
  ];
}
